/* ----------------------------------------------------------------------------
 * AVISE-ME QUANDO CHEGAR (lista de espera por WhatsApp)
 * ----------------------------------------------------------------------------
 *
 * Par do snippets/avise-me.liquid. E um asset carregado pelo layout, e nao um
 * <script> dentro do snippet, pelo mesmo motivo do custom-variant-picker.js:
 * a gaveta "Adicionar rapido" injeta o conteudo da PDP por <template>, e script
 * que nasce ali nao executa. Aqui o listener e de submit no document, entao
 * funciona na PDP e em qualquer gaveta, sem observar nada.
 *
 * Grava em POST /rest/v1/lista_espera do Supabase dos leads (anon key publica,
 * a mesma do popup do zap; a tabela so aceita INSERT do anon, ninguem le por
 * ela). 201 = entrou. 409 = ja estava na lista desse produto (indice unico
 * whatsapp + produto_handle). Qualquer outra coisa = erro, e a cliente pode
 * tentar de novo.
 *
 * Telefone: guarda so digitos no padrao 55DDDNNNNNNNN (mesma regra das bases
 * de disparo). 10 ou 11 digitos ganham o 55; 12 ou 13 comecando com 55 passam.
 * -------------------------------------------------------------------------- */

(function () {
  var URL_TABELA = 'https://zhdapckcsibmofworhjj.supabase.co/rest/v1/lista_espera';
  var CHAVE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpoZGFwY2tjc2libW9md29yaGpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2Mjg5ODYsImV4cCI6MjA4ODIwNDk4Nn0.tS9s-gazJVxGd6WPHk7nryPx9UAO0N-A-w60d3ICIvc';

  function normalizar(valor) {
    var d = String(valor || '').replace(/\D/g, '').replace(/^0+/, '');
    if (d.length === 10 || d.length === 11) d = '55' + d;
    return d;
  }
  function valido(d) { return /^55[1-9][0-9]{9,10}$/.test(d); }

  function mostrar(form, texto, tipo) {
    var msg = form.querySelector('.avise-me__msg');
    if (!msg) return;
    msg.textContent = texto;
    msg.setAttribute('data-tipo', tipo || 'erro');
    msg.hidden = false;
  }

  function concluir(form, nome) {
    var caixa = form.closest('[data-avise-me]');
    if (!caixa) return;
    var ok = caixa.querySelector('.avise-me__ok');
    var span = ok && ok.querySelector('[data-nome]');
    if (span) span.textContent = nome || 'tudo certo';
    form.hidden = true;
    if (ok) ok.hidden = false;
    caixa.classList.add('is-ok');
  }

  function utm(nome) {
    try { return new URLSearchParams(location.search).get(nome) || null; } catch (e) { return null; }
  }

  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (!form || !form.classList || !form.classList.contains('avise-me__form')) return;
    evento.preventDefault();

    if (form.elements.site && form.elements.site.value) return; // robo preencheu a isca

    var nome = (form.elements.nome.value || '').trim();
    var zap = normalizar(form.elements.whatsapp.value);
    if (nome.length < 2) { mostrar(form, 'Me diz seu nome pra eu te chamar direito.'); return; }
    if (!valido(zap)) { mostrar(form, 'Confere o número: DDD + número, tipo 19 99999 9999.'); return; }

    var botao = form.querySelector('button[type="submit"]');
    if (botao) botao.disabled = true;
    mostrar(form, 'Anotando...', 'info');

    var corpo = {
      produto_handle: form.dataset.produtoHandle,
      produto_titulo: form.dataset.produtoTitulo,
      variante_id: form.dataset.varianteId ? Number(form.dataset.varianteId) : null,
      nome: nome,
      whatsapp: zap,
      origem: form.closest('.quick-buy-drawer, quick-buy-drawer') ? 'gaveta' : 'pdp',
      url: location.href.split('?')[0],
      utm_source: utm('utm_source'),
      utm_medium: utm('utm_medium'),
      utm_campaign: utm('utm_campaign')
    };

    fetch(URL_TABELA, {
      method: 'POST',
      headers: {
        'apikey': CHAVE_ANON,
        'Authorization': 'Bearer ' + CHAVE_ANON,
        'Content-Type': 'application/json',
        'Prefer': 'return=minimal'
      },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      if (r.status === 201 || r.status === 200 || r.status === 204) {
        concluir(form, nome);
        if (window.dataLayer) window.dataLayer.push({ event: 'avise_me', produto: corpo.produto_handle });
        return;
      }
      if (r.status === 409) {
        concluir(form, nome);   // ja estava na lista: pra cliente, o resultado e o mesmo
        return;
      }
      throw new Error('HTTP ' + r.status);
    }).catch(function (erro) {
      if (botao) botao.disabled = false;
      mostrar(form, 'Não consegui anotar agora. Tenta de novo em um minuto?');
      if (window.console) console.warn('[avise-me]', erro);
    });
  });
})();
